import { RouteObject } from "react-router-dom";

export const internalAuditingRoutes: RouteObject = {
  id: "internalAuditing",
  path: "auditing",
  lazy: async () => {
    const { InternalAuditingPage } = await import(
      "features/internal/auditing/InternalAuditingPage"
    );
    return { Component: InternalAuditingPage };
  },
};
